<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  list-style: none;
  user-select: none;
}
body,html{
  background: #f1f1f1;
  font-family: '微软雅黑';
}
</style>



// WEBPACK FOOTER //
// src/App.vue